var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"640px"},on:{"click:outside":_vm.hanleClickOutside},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"overflow-y-hidden",attrs:{"height":"400"}},[_c('youtube',{attrs:{"video-id":"V_g_Wb4-mIQ","player-height":"400"},on:{"ready":_vm.ready}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }